export const styleDiagramText = (currentValue, maxValue) => {
  let widthInNumb = Math.floor(currentValue/maxValue*100)
  widthInNumb = (widthInNumb || 0);

  return {
    width: widthInNumb ? widthInNumb + "%" : "2%",
  }
}